import { gql } from "lib/apolloClient";

export const configurationItemFragment = {
  configurationItem: gql`
    fragment configurationV2Item on ConfigurationV2 {
      id
      uidV2
      configuration
      aclControlParameterType
      valueType
      value
      isLocked
    }
  `,
  configurationSettingItem: gql`
    fragment configurationV2SettingItem on ConfigurationV2 {
      id
      uidV2
      configuration
      aclControlParameterType
      valueType
      value
      isLocked
      state
      channelTypeCategorizedValues(
        filters: { isAdminNotificationManager: $isAdminNotificationManager }
      ) {
        push
        email
        inApp
      }
      # required for notification settings -> select classes
      disabledEntityGroups(filters: { entityTypeGroups: [COURSE] }) {
        entities {
          entityId
          entityType
          resolvedEntity {
            ... on Course {
              id
              title
              curriculumProgram {
                id
                type
              }
            }
          }
        }
      }
      # Setting specific fields
      validPlatforms
      platformCategorizedValues(isCourseModuleSetting: $isCourseModuleSetting) {
        default
        staff
        parent
        student
      }
      configurationGroup
      parentConfigurations {
        id
      }
    }
  `,
};

export const configurationFragment = {
  configurationResponse: gql`
    fragment configurationResponseItem on ConfigurationResponse {
      configurations @include(if: $isSettingsPage) {
        ...configurationV2SettingItem
      }
      configurations @skip(if: $isSettingsPage) {
        ...configurationV2Item
      }

      entityGroups @include(if: $isAdminPage) {
        entityId
        entityType
      }
    }
    ${configurationItemFragment.configurationSettingItem}
    ${configurationItemFragment.configurationItem}
  `,
  preferenceResponse: gql`
    fragment configurationResponseItem on ConfigurationResponse {
      configurations @include(if: $isSettingsPage) {
        ...configurationV2SettingItem
      }
      configurations @skip(if: $isSettingsPage) {
        ...configurationV2Item
      }

      entityGroups @include(if: $isAdminPage) {
        entityId
        entityType
      }
    }
    ${configurationItemFragment.configurationSettingItem}
    ${configurationItemFragment.configurationItem}
  `,
};

export const videoMeetingToastEventFragment = gql`
  fragment videoMeetingToastEvent on PlatformCalendarEvent {
    id
    startTime
    endTime
    item {
      ... on CalendarEventItem {
        id
        label
        sharedWith
        associatedEntities(filters: $associatedEntitiesFilters) {
          id
        }
        users {
          id
        }
        meeting {
          id
          type
          createdBy {
            id
          }
          urls {
            ... on ZoomMeetingUrls {
              joinUrl
              startUrl
            }
            ... on GoogleMeetingUrls {
              url
              meetingCode
            }
            ... on MicrosoftTeamMeetingUrls {
              joinWebUrl
              joinUrl
              meetingCode
            }
            ... on OtherMeetingUrls {
              url
            }
          }
        }
      }
    }
  }
`;

export const curriculumProgramFragment = {
  curriculumProgramBasicDetailsWithSubscriptionPlan: gql`
    fragment curriculumProgramBasicDetailsWithSubscriptionPlanItem on CurriculumProgram {
      id
      type
      nodeInterfaceType
      label
      acronym
      academicSetupType
      subscriptionPlan {
        id
        type
        isFree
        label
      }
      buddy {
        id
        email
        firstName
        lastName
      }
      curriculumProgramData {
        subscriptionPlan
      }
      programType
      logo
    }
  `,
  curriculumProgramBasicDetails: gql`
    fragment curriculumProgramBasicDetailsItem on CurriculumProgram {
      id
      type
      nodeInterfaceType
      label
      acronym
      academicSetupType
    }
  `,
};
